/* eslint-disable */
<template>
<div class="question">
  <div class="body">
    <div class="body-content">
      <div>{{question.body}}</div>
    </div>
    <div class="body-option">
      <div v-for="(option, index) in question.option">
        <div class="option" @click="answer(index)">
            <input class="single-click" type="radio" :checked="user_choice == index" />
            <div>{{option}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
require('@/assets/css/question.css');
export default {
  name: 'SingleChoiceQuestion',
  props: ['question'],
  data() {
    return {
      user_choice: null
    }
  },
  methods: {
    answer: function(ans){
      this.user_choice = ans
      this.$emit('answer', this.question.id, ans)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/template/question/SingleChoiceQuestion.vue